import React, {useEffect, useState} from "react";
import './WeatherStationDetails.scss';
import Spinner from "./_common/Spinner";
import WeatherStationModal from "./WeatherStationModal";

const WeatherStationDetails = props => {
    const {station} = props;
    const [pending, setPending] = useState(true)

    useEffect(() => {
        setPending(true)
        setTimeout(() => setPending(false), 300)
    },[station])

    if(pending) {
        return (
            <div className='spinnerWrapper'>
                <Spinner size={300} />
            </div>
        )
    }

    return (
        <div className="WeatherStationDetails">
            <WeatherStationModal
                edit
                station={station}
                details
            />
        </div>
    )

}

export default WeatherStationDetails
